export default "__VITE_ASSET__CpHsh_qx__"